import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
/**
 * Derives relative route paths from a map of absolute paths.
 * Strips the leading `root` segment so the results can be used directly
 * inside a nested <Routes> that is mounted under `root/*`.
 *
 * Example:
 * toRelativePaths(NUDGE_ROUTES, NUDGE_ROUTES.root)
 * // { root: '', single: ':nudgeId', singleAnalytics: ':nudgeId/analytics', … }
 *
 * Rule of thumb:
 * - Use this for route-map normalization in nested routers.
 * - Do not use this for one-off URL generation (for example `generatePath`).
 *
 * @param routes - Map of named absolute path strings
 * @param root - The absolute root path to strip from each entry
 * @returns Map of named relative path strings
 */
export function toRelativePaths(routes, root) {
  var routeEntries = Object.entries(routes);
  return Object.fromEntries(routeEntries.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      path = _ref2[1];
    return [key, path === root ? '' : path.startsWith("".concat(root, "/")) ? path.slice(root.length + 1) : path];
  }));
}